import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-6 text-lg-h6" }
const _hoisted_2 = { class: "ma-4" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_4 = {
  class: "mt-1",
  style: {"width":"150px"}
}
const _hoisted_5 = { class: "d-flex justify-end mr-4" }

import { reactive, computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DynamicForm',
  props: {
    model: {},
    headers: {},
    title: {},
    excludedKeys: {}
  },
  emits: ["submit", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const shouldShow = (key: string) => {
  return !(props.excludedKeys?.some(keyword => key.includes(keyword)))
}

const emits = __emit

const form = reactive({ ...props.model })
const fieldKeys = computed(() => Object.keys(props.model))

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    width: "500",
    class: "pa-4"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.title ?? '请填写事件结果'), 1),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fieldKeys.value, (key, index) => {
          return (_openBlock(), _createElementBlock("div", { key: key }, [
            (shouldShow(key))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.headers?.[index] || key), 1),
                  _createVNode(_component_v_text_field, {
                    density: "compact",
                    variant: "outlined",
                    modelValue: form[key],
                    "onUpdate:modelValue": ($event: any) => ((form[key]) = $event),
                    placeholder: '请输入' + (_ctx.headers?.[index] || key),
                    type: typeof form[key] === 'number' ? 'number' : 'text',
                    clearable: ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "type"])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_btn, {
          color: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('submit',{ ...form })))
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("提交")
          ])),
          _: 1,
          __: [2]
        }),
        _createVNode(_component_v_btn, {
          color: "red-lighten-2",
          class: "ml-4",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('close')))
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode("取消")
          ])),
          _: 1,
          __: [3]
        })
      ])
    ]),
    _: 1
  }))
}
}

})